import React from "react";

export const RequiredAsterisk = () => (
  <span className="required-asterisk" aria-hidden="true">
    *
  </span>
);
